import * as React from "react";
import { useMemo, useState } from "react";

import { ChevronDown, ChevronUp } from "@livechat/design-system-icons";
import { ActionMenu, ActionMenuItem, Button, IActionMenuOption, Icon } from "@livechat/design-system-react-components";

import PriorityIndicator from "components/priority/PriorityIndicator";
import { TICKET_PRIORITY_LABEL_MAP } from "constants/tickets/priorities";
import { ITicket, TicketPriority } from "interfaces/entities/ticket";

interface IProps {
  ticket: ITicket;
  onPriorityUpdate(priority: TicketPriority): void;
  disabled: boolean;
}

const PrioritySwitcher: React.FC<IProps> = ({ ticket, disabled, onPriorityUpdate }) => {
  const [toggled, setToggled] = useState(false);

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handlePrioritySelect = (newPriority: TicketPriority) => {
    onPriorityUpdate(newPriority);
    setToggled(false);
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleClose = () => {
    setToggled(false);
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleOpen = () => {
    setToggled(true);
  };

  const options = useMemo<IActionMenuOption[]>(
    () =>
      [TicketPriority.Urgent, TicketPriority.High, TicketPriority.Medium, TicketPriority.Low].map(priority => ({
        key: priority.toString(),
        element: (
          <ActionMenuItem leftNode={<PriorityIndicator priority={priority} />}>
            {TICKET_PRIORITY_LABEL_MAP[priority]}
          </ActionMenuItem>
        ),
        disabled,
        // FIXME: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        onClick: () => handlePrioritySelect(priority),
      })),

    [disabled, handlePrioritySelect, ticket.priority]
  );

  return (
    <div data-testid="ticket-details-priority-button" css={{ display: "inline-flex" }}>
      <ActionMenu
        visible={toggled}
        placement="bottom-start"
        selectedOptions={[ticket.priority.toString()]}
        options={options}
        onClose={handleClose}
        triggerRenderer={
          <Button
            size="xcompact"
            disabled={disabled}
            kind="secondary"
            iconPosition="right"
            icon={<Icon source={toggled ? ChevronUp : ChevronDown} />}
            onClick={handleOpen}
            css={{ fontWeight: 400 }}
          >
            {TICKET_PRIORITY_LABEL_MAP[ticket.priority]}
          </Button>
        }
      />
    </div>
  );
};

export default PrioritySwitcher;
